/*  SAME SEARCH v-data-table DOES WITH :search, BUT RUN OUTSIDE THE TABLE
    ::: CLIFF :::
    A paged table only hands back the rows on the current page (@current-items), so dashboards that count or
    summarize "everything matching the search" filter here instead and pass the result to :items.

    Matches when any searchable column's value contains the (trimmed) search text, ignoring case and booleans,
    exactly like Vuetify's default filter. Columns with a custom filter or filterable: false are skipped, as Vuetify does.

    defaultFilter & getObjectValueByPath are copied from vuetify/lib/util/helpers.js (Vuetify 2.3) instead of imported:
    our webpack 3 build doesn't transpile node_modules, and that file uses syntax it can't parse.
*/

function defaultFilter ( value, search ) {
    return value != null && search != null && typeof value !== 'boolean' &&
        value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
}

function getNestedValue ( obj, path ) {
    const last = path.length - 1
    if ( last < 0 ) return obj
    for ( let i = 0; i < last; i++ ) {
        if ( obj == null ) return undefined
        obj = obj[path[i]]
    }
    return obj == null ? undefined : obj[path[last]]
}

function getObjectValueByPath ( obj, path ) {
    if ( obj == null || !path || typeof path !== 'string' ) return undefined
    if ( obj[path] !== undefined ) return obj[path]
    path = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '')
    return getNestedValue(obj, path.split('.'))
}

export function searchTableRows ( rows, headers, search ) {
    const term = typeof search === 'string' ? search.trim() : ''
    if ( !term ) return rows

    const columns = (headers || []).filter(header =>
        !header.filter && (!Object.prototype.hasOwnProperty.call(header, 'filterable') || header.filterable === true)
    )

    return (rows || []).filter(row =>
        columns.some(header => defaultFilter(getObjectValueByPath(row, header.value), term))
    )
}



// WEBPACK FOOTER //
// ./src/helpers/tableSearch.js